import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://adminserver-production-f32d.up.railway.app',
  // Puoi aggiungere altre configurazioni qui, come headers, timeout, ecc.
});

export default axiosInstance; 